'use client';

import { useCallback } from 'react';

import { useRouter } from 'next/navigation';

import { useCheckoutStore } from '@/stores';
import { CheckoutStep, ROUTES } from '@/types/enums';
import type { Raffle } from '@/types/models';

type UseRaffleCardProps = {
  raffle: Raffle;
};

type UseRaffleCardReturn = {
  handleBuyClick: () => void;
  handleDetailsClick: () => void;
};

export const useRaffleCard = ({ raffle }: UseRaffleCardProps): UseRaffleCardReturn => {
  const router = useRouter();
  const { setPurchaseData, setCurrentStep } = useCheckoutStore();

  const handleBuyClick = useCallback(() => {
    const ticketsAmount = raffle.initialTicketsAmount || 1;
    const ticketPrice = raffle.ticketPrice || 0;
    const totalValue = ticketsAmount * ticketPrice;

    setPurchaseData({
      raffleId: raffle.id,
      ticketsAmount,
      totalValue,
      raffleName: raffle.name,
      ticketPrice: raffle.ticketPrice,
      prizeValue: raffle.prizeValue,
      drawDate: raffle.drawDate,
      isPromotionAvailable: raffle.isPromotionAvailable,
      promotionPercentage: raffle.promotionPercentage,
      promotionTicketsAmount: raffle.promotionTicketsAmount,
      promotionTitle: raffle.promotionTitle,
      promotionDescription: raffle.promotionDescription,
      minTicketsPerPurchase: raffle.minTicketsPerPurchase,
      maxTicketsPerPurchase: raffle.maxTicketsPerPurchase,
    } as Record<string, unknown>);

    setCurrentStep(CheckoutStep.FORM);

    router.push(`${ROUTES.Enum.detalhes}/${raffle.id}`);
  }, [raffle, setPurchaseData, setCurrentStep, router]);

  const handleDetailsClick = useCallback(() => {
    router.push(`${ROUTES.Enum.detalhes}/${raffle.id}`);
  }, [raffle, router]);

  return {
    handleBuyClick,
    handleDetailsClick,
  };
};
